module.exports = __webpack_public_path__ + "img/game-expired.f14f8aac.png";